import { Link } from "react-router";
import { PageShell } from "../../ui/PageShell";
import { StatsOverview } from "../../ui/StatsOverview";

/** `/stats`: the full public statistics page (docs/00 R10). */
export function StatsPage() {
  return (
    <PageShell title="Town statistics">
      <p className="stats-lead">
        Measured, explainable activity for the whole town. Per-building numbers (current owner vs lifetime) are on each listing's panel in
        the <Link to="/">town</Link> or the <Link to="/directory">directory</Link>.
      </p>
      <StatsOverview active />
    </PageShell>
  );
}
